import {
  CardLoading,
  CardNotice,
  ChatCard,
} from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { WandSparkles } from 'lucide-react-native';
import { memo } from 'react';
import { ChangesCard } from './ChangesCard';
import { useBiChangeSet } from './functions/useBiChangeSet';

/** A change set by id: loading, missing or failed, then its card. */
export const ChangeSetCard = memo(
  ({ changeSetId }: { changeSetId: string }) => {
    const state = useBiChangeSet(changeSetId);
    if (state.kind === 'ready') return <ChangesCard detail={state.detail} />;
    return (
      <ChatCard icon={WandSparkles} color={aiColors.amber} title="看板修改建议">
        {state.kind === 'loading' ? (
          <CardLoading label="正在读取修改…" />
        ) : state.kind === 'missing' ? (
          <CardNotice text="这条修改已不可用，请重新提问。" />
        ) : (
          <CardNotice tone="danger" text="修改没有加载出来，请稍后重试。" />
        )}
      </ChatCard>
    );
  },
);
